import logo from './img/logo-blanc.png';
import image from './img/essence.png';
import { metadata } from '../engine/eligibility';

export default function StartScreen({ onStart }) {
  return (
    <div className="start-screen">
      <div className="start-screen__inner">
        <div className="start-screen__visual desktop-only">
          <img src={image} alt="" className="start-screen__hero" />
          <img src={logo} alt="Logo" className="start-screen__logo" />
        </div>
        <div className="start-screen__content">
          <h1>
            Avez-vous droit à{' '}
            <span className="accent">l&apos;aide de {metadata.amount}&nbsp;€</span>
            <br />
            pour les travailleurs grands rouleurs&nbsp;?
          </h1>
          <img className="mobile-only start-screen__hero" src={image} alt="" />
          <p className="start-screen__lead">
            Quelques questions et vous saurez si vous êtes éligible.
          </p>
          <p className="start-screen__info">
            <u>Informations à prévoir</u> : RFR {metadata.reference_year} et nombre de parts
            (avis d&apos;imposition {metadata.tax_notice_year}).
          </p>
          <button type="button" className="btn btn-cta" onClick={onStart}>
            C&apos;est parti !
          </button>
          <img src={logo} alt="Logo" className="mobile-only start-screen__logo-mobile" />
        </div>
      </div>
    </div>
  );
}
